import { apiGet, apiPost } from './client.js';

export function getPricing() { return apiGet('/api/billing/pricing'); }
export function createCheckout(tier, interval) { return apiPost('/api/billing/checkout', { tier, interval }); }
export function getCheckoutStatus(sessionId) { return apiGet(`/api/billing/checkout-status/${sessionId}`); }
export function createPortalSession() { return apiPost('/api/billing/portal'); }
export async function getUsage() {
  try {
    return await apiGet('/api/billing/usage');
  } catch (err) {
    if (err.status === 402) return null;
    throw err;
  }
}
